/**
 * Personstamm API
 * API for Personstamm Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { CodeEntryMeta } from './codeEntryMeta';
import { DateEntryMeta } from './dateEntryMeta';
import { PersonAdresseListEntryMeta } from './personAdresseListEntryMeta';


export interface PersonStammListEntryMeta { 
    anrede?: CodeEntryMeta;
    mAnrede?: FieldMetaData;
    art?: PersonStammListEntryMeta.ArtEnum;
    mArt?: FieldMetaData;
    bezeichnung?: string;
    mBezeichnung?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    fremdId?: string;
    mFremdId?: FieldMetaData;
    isGueltig?: boolean;
    mIsGueltig?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    geburtsdatum?: DateEntryMeta;
    mGeburtsdatum?: FieldMetaData;
    mitGrundbuchbezug?: boolean;
    mMitGrundbuchbezug?: FieldMetaData;
    unternehmensId?: string;
    mUnternehmensId?: FieldMetaData;
    adressen?: Array<PersonAdresseListEntryMeta>;
    mAdressen?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
}
export namespace PersonStammListEntryMeta {
    export type ArtEnum = 'ALLE_PERSON' | 'NATUERLICHE_PERSON' | 'JURISTISCHE_PERSON' | 'GEMEINSCHAFT' | 'OEFFENTLICH_RECHTLICHE_PERSON';
    export const ArtEnum = {
        ALLEPERSON: 'ALLE_PERSON' as ArtEnum,
        NATUERLICHEPERSON: 'NATUERLICHE_PERSON' as ArtEnum,
        JURISTISCHEPERSON: 'JURISTISCHE_PERSON' as ArtEnum,
        GEMEINSCHAFT: 'GEMEINSCHAFT' as ArtEnum,
        OEFFENTLICHRECHTLICHEPERSON: 'OEFFENTLICH_RECHTLICHE_PERSON' as ArtEnum
    };
}


